import { DateTime } from 'luxon';
import { z } from 'zod';

import { parseTimestamp } from '../lib/date-time.js';
import { SignalDirection } from './signal-direction';
import { SignalType } from './signal-type.js';

const detectionDtoSchema = z.object({
  id: z.string(),
  deviceId: z.string(),
  direction: z.nativeEnum(SignalDirection),
  direction_accuracy: z.number().optional(),
  direction_delta: z.number().optional(),
  frequency: z.number(),
  signalType: z.nativeEnum(SignalType),
  isManual: z.boolean(),
  bandwidth: z.number().optional(),
  offset: z.number(),
  signalLevel: z.number().optional(),
  snr: z.number().optional(),
  patternType: z.string().optional(),
  ts: z.string(),
  createdAt: z.string(),
  detectionGroupId: z.string().nullish(),
  detectionGroupCreatedAt: z.string().nullish(),
});

export const detectionSchema = detectionDtoSchema.transform((detection) => ({
  id: detection.id,
  deviceId: detection.deviceId,
  direction: detection.direction,
  direction_accuracy: detection.direction_accuracy,
  direction_delta: detection.direction_delta,
  frequency: detection.frequency,
  signalType: detection.signalType,
  isManual: detection.isManual,
  bandwidth: detection.bandwidth,
  offset: detection.offset,
  signalLevel: detection.signalLevel,
  snr: detection.snr,
  patternType: detection.patternType,
  ts: detection.ts,
  createdAt: parseTimestamp(detection.createdAt) as DateTime,
  detectionGroupId: detection.detectionGroupId,
  detectionGroupCreatedAt: detection.detectionGroupCreatedAt,
}));

export const detectionListSchema = z.object({
  detections: z.array(detectionSchema),
  total: z.number(),
});

export type Detection = z.infer<typeof detectionSchema>;
